// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ContentComponentItemFragmentDoc } from '../ContentComponentItem.fragment.generated';
export const SquareTextBoxFragmentDoc = gql`
    fragment squareTextBox on SquareTextBox {
  __typename
  backgroundColor
  content {
    ...contentComponentItem
  }
}
    ${ContentComponentItemFragmentDoc}`;